// extracted by mini-css-extract-plugin
module.exports = {"header":"_7a3fb80146--header--nkW9A","content":"_7a3fb80146--content--ad5yf","container":"_7a3fb80146--container--XIFyd"};